import { render, staticRenderFns } from "./RoulettesIFrame.vue?vue&type=template&id=2555881a&scoped=true"
import script from "./RoulettesIFrame.vue?vue&type=script&lang=js"
export * from "./RoulettesIFrame.vue?vue&type=script&lang=js"
import style0 from "./RoulettesIFrame.vue?vue&type=style&index=0&id=2555881a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2555881a",
  null
  
)

export default component.exports